import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconPointer';
/** Renders an SVG icon. */
const SvgPointer = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M16.902 26.939c-.682 1.705-3.109 1.667-3.736-.059L6.439 8.381c-.44-1.213.754-2.38 1.956-1.91l19.157 7.497c1.793.702 1.655 3.285-.204 3.792l-7.603 2.074zm1.17-8.31c.117-.291.364-.511.666-.594l8.085-2.205L8.696 8.737l6.35 17.46z"
      />
    </svg>
  );
};
SvgPointer.displayName = displayName;
export default SvgPointer;
